import { AxiosError } from 'axios';
import { useState } from 'react';

// import toast from 'react-hot-toast';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useCompanySearch = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [fetchedCompanyData, setFetchedCompanyData] = useState<any[]>([]);

    const onSearchCompanyError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(
            err?.response?.data?.message ??
            'Something went wrong while searching for the company.',
        );
    };

    const onSearchCompanySuccess = ({
        data,
        message,
    }: SuccessHttpResponse<SearchCompanyDataResponse>) => {
        // toast.success('Company search completed successfully.');
        setFetchedCompanyData(data?.records || []);
    };

    const searchCompany = (searchCompany: string, isAssigned = true) => {
        // const urlString = `api/v1/company/search-companies?isAssigned=${isAssigned}&page=0&size=50${searchCompany ? `&query=${searchCompany}` : ''}`;
        const urlString = `ba/v1/company?search=${searchCompany}&page=0&size=50&sort=createdAt%2CDESC`;
        // https://dev-api.logirate.org/ba/v1/company?search=abc&page=0&size=10&sort=createdAt%2CDESC
        const url: HttpConfig = {
            url: urlString,
            // url: `api/v1/company/search-companies?query=${searchCompany}`,
            method: 'get',
            // data: {},
        };
        request(url, onSearchCompanySuccess, setLoading, onSearchCompanyError);
    };

    return { searchCompany, loading, fetchedCompanyData };
};

export default useCompanySearch;


interface SearchCompanyResponse {
    accountCreatorRole: string;
    availableLookupCount: number;
    createdAt: string;
    email: string;
    fleetCategories: string[];
    fleetSize: string;
    freeLookupCount: number;
    id: string;
    industryType: string;
    isTestMode: boolean;
    isWithinFreeTrial: boolean;
    kycStatus: string;
    name: string;
    phoneNumber: string;
    profilePicture: any;
    registrationNumber: string;
    status: string;
    totalAvailableLookupCount: number;
    totalDrivers: number;
    typicalRoute: string;
    updatedAt: string;
}

interface SearchCompanyDataResponse {
    records: SearchCompanyResponse[];
    totalRecords: number;
    totalPages: number;
}
